import { render } from "./ModelFail.vue?vue&type=template&id=2762db2a"
import script from "./ModelFail.vue?vue&type=script&lang=js"
export * from "./ModelFail.vue?vue&type=script&lang=js"

import "./ModelFail.vue?vue&type=style&index=0&id=2762db2a&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__